"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _CheckboxField = _interopRequireDefault(require("../../form/CheckboxField"));

var _styling = require("../../../toolkit/styling");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NumColumns = 2;

var TableColumnPicker = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TableColumnPicker, _Component);

  var _super = _createSuper(TableColumnPicker);

  function TableColumnPicker() {
    (0, _classCallCheck2["default"])(this, TableColumnPicker);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TableColumnPicker, [{
    key: "renderColumn",
    value: function renderColumn(columnIndex) {
      var _this = this;

      var _this$props = this.props,
          columns = _this$props.columns,
          onColumnToggled = _this$props.onColumnToggled,
          selectedKeys = _this$props.selectedKeys;

      if (columnIndex > columns.length) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: columnIndex,
        className: (0, _styling.css)(this.styles.column)
      }, columns.map(function (column, idx) {
        if (idx % NumColumns !== columnIndex) {
          return null;
        }

        if (!column.title) {
          return null;
        }

        return /*#__PURE__*/_react["default"].createElement(_CheckboxField["default"], {
          title: column.title || undefined,
          description: column.description,
          onChange: function onChange() {
            return onColumnToggled(column);
          },
          checked: selectedKeys.includes(column.columnKey),
          className: (0, _styling.css)(_this.styles.item)
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var columns = []; // eslint-disable-next-line local-rules/no-c-style-for-loop

      for (var idx = 0; idx < NumColumns; idx++) {
        columns.push(this.renderColumn(idx));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root)
      }, columns));
    }
  }, {
    key: "styles",
    get: function get() {
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          backgroundColor: "white",
          borderRadius: 4,
          padding: "15px 0px",
          zIndex: 50000
        },
        column: {
          display: "flex",
          flexDirection: "column",
          marginLeft: 10,
          paddingLeft: 10,
          borderLeft: "solid 1px #eeefef",
          ":first-child": {
            marginLeft: 0,
            borderLeft: "none"
          }
        },
        item: {
          marginBottom: 17
        }
      });
    }
  }]);
  return TableColumnPicker;
}(_react.Component), _class3.demoProps = {
  columns: [{
    title: "milk",
    columnKey: "milk",
    description: "description of milk"
  }, {
    title: "eggs",
    columnKey: "eggs",
    description: "description of eggs"
  }, {
    title: "cheese",
    columnKey: "cheese",
    description: "description of cheese"
  }, {
    title: "bread",
    columnKey: "break",
    description: "description of bread"
  }, {
    title: "water",
    columnKey: "water",
    description: "description of water"
  }],
  onColumnToggled: function onColumnToggled() {},
  selectedKeys: ["cheese", "milk"]
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = TableColumnPicker;
exports["default"] = _default;